import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        //GENEL
        success: "Success !",
        cancel: "Cancel",
        register: "Hesabınız yok mu? 15 gün ücretsiz deneyim için hemen kayıt olun!",

        welcome: "Welcome",
        username: "Username",
        password: "Password",
        youcanlogin: "You can log in with your username and password",
        login: "Login",
        forgetPassword: "Did you forget your password ?",
        takeRenewalLink:
          "You can get the password renewal link to your email address",
        mail: "Mail",
        sendRenewalLink: "Send Password Renewal Link",
        enterNewPassword: "Enter your new password",
        newPassword: "New Password",
        createAcc: "Create A New Account",
        haveAccount: "Already have an account? Log in.",
        phone: "Phone",
        signup: "Sign Up",
        userInformation: "User Information",
        continue: "Continue",


        personalInfo: "Personal Info",
        createAccountDescription: "By filling in the required fields, you can register in the system and start using the full 15-day trial version. It is very important to provide accurate and complete information due to legal obligations. Please make sure to enter your details carefully.",
        requiredFields: "Required Fields",
        name: "Name",
        surname: "Surname",
        identityNumber: "Identity Number",
        vkn: "vkn",
        birthday: "Birthday",
        accountInfo: "Account Info",
        confirmPassword: "Confirm Password",
        contactInfo: "Contact Info",
        phone2: "Phone - 2",
        birthInfo: "Birth Info",
        birthCountry: "Birth Country",
        birthDistrict: "Birth District",
        residentialAddress: "Residential Address",
        residentialDistrict: "Residential District",
        residentialCountry: "Residential Country",
        residentialDetail: "Residential Detail",
        workAddress: "Work Address",
        workDistrict: "Work District",
        workCountry: "Work Country",
        workDetail: "Work Detail",
        kvkkAgreement: "KVKK Agreement",
        companyName: "Company Name",
        agreementsAndConsents: "Agreements and Consents",
        distanceSalesContract: "Distance Sales Contract",
        distanceSalesAgreement: "I accept the distance sales contract.",

        //Ödeme Sayfası
        pricingPlans: "Pricing Plans",
        monthly: "Monthly",
        threeMonth: "3 Monthly",
        sixMonth: "6 Monthly",
        annual: "Annual",
        paymentSuccess: "Your payment has been completed successfully.",
        selectPlanSubtitle: "You can continue by choosing the payment plan that suits you.",
        discount: "Discount",
        month: "Month",
        fullAccess: "Full Access",
        dedicatedSupport: "Dedicated Support",
        regularUpdates: "Regular Updates",
        selected: "Selected",
        selectPlan: "Select Plan",
        paymentDetails: "Payment Details",
        bankAccounts: "Bank Accounts",
        total: "Total",
        payWithCreditCard: "Pay with Credit Card",
        taxesIncluded: "Taxes Included",
        bankTransfer: "Bank Transfer",
        withBankTransfer: "With Bank Transfer",
        extraDiscount: "Extra Discount",
        bankTransferDescription: "Take advantage of the bank transfer opportunity!",
        creditCardDescription: "Possibility of installment up to 12 months with credit card !",
        payWithTransfer: "Pay with Bank Transfer",
        creditCard: "Credit Card",
        confirmTransfer: "Confirm Transfer",
        payNow: "Pay Now",
        paymentSummary: "Payment Summary",
        pageNotFound: "Page Not Found !",
        pageNotFoundMessage: "Oops! The page you’re looking for doesn’t exist.It might have been moved, deleted, or the URL might be incorrect.Please check the address or use the buttons below to return.",
        goBack: "Back",
        goHome: "Homepage",
        goLogin: "Login",
        noSurprise: "No surprise payments",
        listPrice: "List Price",
        discountedPrice: "Discounted Price",
        bankTransferPrice: "Bank Transfer Price",
        paymentConfirmation: "Payment Confirmation",
        transferRecorded: "Transfer Recorded",
        activationMessage: "Your payment has been received. After the payment is verified, your membership will be activated within a maximum of 2 hours.",
        paymentInformation: "Payment Information",
        amount: "Amount",
        plan: "Plan",
        paymentSuccessful: "Payment Successful",

        //register.js
        nameRequired: "Name is required.",
        surnameRequired: "Surname is required.",
        usernameRequired: "Username is required.",
        emailRequired: "Email is required.",
        invalidEmail: "Please enter a valid email address.",
        passwordMinLength: "Password must be at least 8 characters long.",
        passwordLowercase: "Password must contain at least one lowercase letter.",
        passwordUppercase: "Password must contain at least one uppercase letter.",
        passwordNumber: "Password must contain at least one number.",
        passwordSpecial: "Password must contain at least one special character.",
        passwordRequired: "Password is required.",
        confirmPasswordRequired: "Confirm password is required.",
        passwordsMatch: "Passwords must match.",
        identityNumberFormat: "Identity Number must be 11 digits.",
        identityNumberRequired: "Identity Number is required.",
        vknRequired: "VKN is required.",
        phoneNumberRequired: "Phone number is required.",
        birthCountryRequired: "Birth country is required.",
        birthDistrictRequired: "Birth district is required.",
        birthdayRequired: "Birthday is required.",
        invalidDate: "Please enter a valid date.",
        residentialCountryRequired: "Residential country is required.",
        residentialDistrictRequired: "Residential district is required.",
        residentialDetailRequired: "Residential address detail is required.",
        workCountryRequired: "Work country is required.",
        workDistrictRequired: "Work district is required.",
        workDetailRequired: "Work address detail is required.",
        kvkkRequired: "You must approve the KVKK Agreement.",
        privacyRequired: "You must approve the Privacy Policy.",
        informationRequired: "You must approve the Information Agreement.",
        registerSuccess: "Registration completed successfully.",
        registerError: "Registration failed.",
        passwordRequirements: "Password Requirements",

        //newPassword.js    
        renewPassword: "Reset Password",
        sendResetLink: "Send Password Reset Link",
        enterIdentityNumberForReset: "You can get the password reset link by entering your Identity Number.",
        backToLogin: "Return to Login Screen."
      },
    },
    tr: {
      translation: {
        //GENEL
        success: "Başarılı !",
        cancel: "İptal",
        register: "Hesabınız yok mu? 15 gün ücretsiz deneyim için hemen kayıt olun!",

        welcome: "Hoş Geldiniz !!:",
        username: "Kullanıcı Adı",
        password: "Şifre",
        youcanlogin: "Kullanıcı adı ve parolanızla giriş yapabilirsiniz",
        login: "Giriş Yap",
        forgetPassword: "Şifrenizi mi unuttunuz ?",
        takeRenewalLink:
          "Mail adresinize şifre yenileme bağlantısı alabilirsiniz",
        mail: "Mail",
        sendRenewalLink: "Yenileme Bağlantısı Gönder",
        enterNewPassword: "Yeni şifrenizi giriniz ",
        newPassword: "Yeni şifre",
        createAcc: "Yeni Hesap Oluştur",
        haveAccount: "Zaten bir hesabınız var mı? Giriş yapın.",
        phone: "Telefon Numarası",
        signup: "Kaydol",
        userInformation: "Kullanıcı Bilgileri",
        pageNotFound: "Sayfa bulunamadı !",
        pageNotFoundMessage: "Üzgünüz! Aradığınız sayfa bulunamadı. Sayfa taşınmış, silinmiş ya da bağlantı hatalı olabilir. Lütfen adresi kontrol edin veya aşağıdaki butonları kullanarak devam edin.",
        goBack: "Önceki sayfa",
        goHome: "Anasayfa",
        goLogin: "Giriş",
        continue: "Devam",
        agreementsAndConsents: "Sözleşmeler ve Onaylar",
        distanceSalesContract: "Mesafeli Satış Sözleşmesi",
        distanceSalesAgreement: "Mesafeli satış sözleşmesini kabul ediyorum.",

        personalInfo: "Kişisel Bilgiler",
        createAccountDescription: "Gerekli alanları doldurarak sisteme kayıt olabilir ve 15 gün ücretsiz kullanmaya başlayabilirsiniz. Bilgilerinizi doğru ve eksiksiz girmeniz, yasal yükümlülükler açısından büyük önem taşımaktadır. Lütfen bu konuda dikkatli olunuz.",
        requiredFields: "Zorunlu Alanlar",
        name: "Ad",
        surname: "Soyad",
        identityNumber: "T.C. Kimlik Numarası",
        vkn: "VKN",
        birthday: "Doğum Tarihi",
        accountInfo: "Hesap Bilgileri",
        confirmPassword: "Şifreyi Onayla",
        contactInfo: "İletişim Bilgileri",
        phone2: "İkinci Telefon Numarası",
        birthInfo: "Doğum Bilgileri",
        birthCountry: "İl",
        birthDistrict: "İlçe",
        residentialAddress: "İkametgah Bilgileri",
        residentialDistrict: "İlçe",
        residentialCountry: "İl",
        residentialDetail: "Adres Detayı",
        workAddress: "İş Adresi",
        workDistrict: "İlçe",
        workCountry: "İl",
        workDetail: "Adres Detayı",
        kvkkAgreement: "KVKK Aydınlatma Metni Onayı",
        companyName: "Firma Ünvanı",


        //Ödeme Sayfası
        pricingPlans: "Ödeme Planları",
        monthly: "Aylık",
        threeMonth: "3 Aylık",
        sixMonth: "6 Aylık",
        annual: "Yıllık",
        paymentSuccess: "Ödemeniz başarılı bir şekilde tamamlandı.",
        selectPlanSubtitle: "Size uygun ödeme planını seçerek devam edebilirsiniz.",
        discount: "İndirim",
        month: "Ay",
        fullAccess: "Tam Erişim",
        dedicatedSupport: "Özel destek",
        regularUpdates: "Düzenli güncelleme",
        selected: "Seçildi",
        selectPlan: "Ödeme Planı Seç",
        paymentDetails: "Ödeme Detayları",
        bankAccounts: "Banka Hesaplarımız",
        total: "Toplam",
        payWithCreditCard: "Kredi kartı ile öde",
        taxesIncluded: "Fiyatlarımıza vergiler dahildir ***",
        bankTransfer: "Havale / EFT",
        withBankTransfer: "Havale / EFT ile",
        extraDiscount: "Ek İndirim",
        bankTransferDescription: "Banka transferi fırsatından yararlanın !",
        creditCardDescription: "Kredi kartı ile 12 aya kadar taksit imkanı !",
        payWithTransfer: "Havale / EFT ile öde",
        creditCard: "Kredi / Banka Kartı",
        confirmTransfer: "Transfer Onayla",
        payNow: "Şimdi Öde",
        paymentSummary: "Ödeme Özeti",
        noSurprise: "Sürpriz ödeme yok",
        listPrice: "Liste Fiyatı",
        discountedPrice: "İndirimli Fiyatı",
        bankTransferPrice: "Havale / EFT Fiyatı",
        paymentConfirmation: "Ödeme Onayı",
        transferRecorded: "Ödeme talebiniz kaydedildi",
        activationMessage: "Ödeme kaydınız alınmıştır. Ödemeniz kontrol edildikten sonra en geç 2 saat içerisinde üyeliğiniz aktif hale getirilecektir.",
        paymentInformation: "Ödeme Bilgisi",
        amount: "Tutar",
        plan: "Üyelik Planı",
        paymentSuccessful: "Ödemeniz Başarılı",

        //register.js
        nameRequired: "Ad alanı zorunludur.",
        surnameRequired: "Soyad alanı zorunludur.",
        usernameRequired: "Kullanıcı adı zorunludur.",
        emailRequired: "E-posta adresi zorunludur.",
        invalidEmail: "Lütfen geçerli bir e-posta adresi giriniz.",
        passwordMinLength: "Şifre en az 8 karakter olmalıdır.",
        passwordLowercase: "Şifre en az bir küçük harf içermelidir.",
        passwordUppercase: "Şifre en az bir büyük harf içermelidir.",
        passwordNumber: "Şifre en az bir rakam içermelidir.",
        passwordSpecial: "Şifre en az bir özel karakter içermelidir.",
        passwordRequired: "Şifre alanı zorunludur.",
        confirmPasswordRequired: "Şifre onay alanı zorunludur.",
        passwordsMatch: "Şifreler eşleşmelidir.",
        identityNumberFormat: "Kimlik numarası 11 haneli olmalıdır.",
        identityNumberRequired: "T.C. Kimlik Numarası zorunludur.",
        vknRequired: "VKN alanı zorunludur.",
        phoneNumberRequired: "Telefon numarası zorunludur.",
        birthCountryRequired: "Doğum ili zorunludur.",
        birthDistrictRequired: "Doğum ilçesi zorunludur.",
        birthdayRequired: "Doğum tarihi zorunludur.",
        invalidDate: "Lütfen geçerli bir tarih giriniz.",
        residentialCountryRequired: "İkamet ili zorunludur.",
        residentialDistrictRequired: "İkamet ilçesi zorunludur.",
        residentialDetailRequired: "Adres detayı zorunludur.",
        workCountryRequired: "İş adresi ili zorunludur.",
        workDistrictRequired: "İş adresi ilçesi zorunludur.",
        workDetailRequired: "İş adresi detayı zorunludur.",
        kvkkRequired: "KVKK Aydınlatma Metni'ni onaylamanız gerekmektedir.",
        privacyRequired: "Gizlilik Sözleşmesi'ni onaylamanız gerekmektedir.",
        informationRequired: "Aydınlatma Metni'ni onaylamanız gerekmektedir.",
        registerSuccess: "Kayıt işlemi başarıyla tamamlandı.",
        registerError: "Kayıt işlemi başarısız oldu.",
        passwordRequirements: "Şifre gereksinimleri",

        //newPassword.js
        renewPassword: "Şifre yenile",
        sendResetLink: "Şifre yenileme bağlantısı gönder",
        enterIdentityNumberForReset: "T.C. Kimlik numaranızı girerek şifre yenileme bağlantısı alabilirsiniz.",
        backToLogin: "Giriş ekranı"
      },
    },
  },
  lng: localStorage.language || 'tr',
  fallbackLng: localStorage.language || 'tr',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
